export const LIST_FIELD_ALLOW_NULL = [
     'testId',
     'cePackId',
     'certificateId',
     'surveyId',
     'sellingGroupId',
     'startAt',
     'endAt',
     'discountStartAt',
     'discountEndAt',
     'min',
     'quantity',
     'relatedProductProductId',
];

export const LIST_FIELD_ALLOW_UNLIMITED = ['accessExpirationDays', 'quantity', 'max'];

export const LIST_FIELD_NUMBER_LENGTH_LIMITED = ['min', 'max', 'quantity'];

export const FIELD_GROUPS = [
     {
          name: 'System Configuration',
          fields: ['status', 'name', 'licenseeId', 'slug', 'productTypeId'],
     },
     {
          name: 'Require Attestation',
          fields: [
               'showAttestation',
               'attestationHeadline',
               'attestationContent',
               'attestationAcceptContent',
               'attestPurchasedACopy',
               'attestationCheckmarks',
          ],
     },
     {
          name: 'Related Learning Products',
          fields: ['relatedProductProductId', 'relatedProductSubject', 'relatedProductDescription', 'relatedProductButtonText'],
     },
     {
          name: 'Selling Details',
          fields: ['purchaseType', 'sku', 'price', 'quantity', 'min', 'max'],
     },
     {
          name: 'Stripe Product Details',
          fields: ['stripeProductID', 'stripeTestProductID', 'pricingTiers'],
     },
     {
          name: 'Products in Bundle',
          fields: ['listBundleProduct'],
     },
     {
          name: 'Attached Learning Elements',
          fields: ['cePackId', 'testId', 'surveyId', 'certificateId', 'designationElement'],
     },
     {
          name: 'Product Access Expiration',
          fields: ['expireUserAccess', 'accessExpirationDays'],
     },
     {
          name: 'Selling Descriptions',
          fields: [
               'sellingGroupId',
               'publishName',
               'genericPublicName',
               'shortDescription',
               'description',
               'image',
               'sortingOder',
               'purchaseEventCreditHeadline',
          ],
     },

     {
          name: 'Learning Descriptions - My Training/Manage Seats',
          fields: [
               'tableHeadline',
               'tableSubHeadline',
               'tableDescription',
               'tableButtonText',
               'tableOrgHeadline',
               'tableOrgSubHeadline',
               'tableOrgDescription',
          ],
     },
     {
          name: 'Learning Descriptions - My Training/Manage Seats (Related)',
          fields: [
               'relatedTableHeadline',
               'relatedTableSubHeadline',
               'relatedTableDescription',
               'relatedTableButtonText',
               'relatedTableOrgHeadline',
               'relatedTableOrgSubHeadline',
               'relatedTableOrgDescription',
          ],
     },
     {
          name: 'Learning Descriptions - Learning Page',
          fields: [
               'pageHeadline',
               'pageSubHeadline',
               'pageBodyText',
               'pageImage',
               'pageAuthor',
               'pageOverview',

               'pageOrgHeadline',
               'pageOrgSubHeadline',
               'pageOrgBodyText',
               'pageOrgImage',
               'pageOrgAuthor',
               'pageOrgOverview',
          ],
     },
     {
          name: 'Learning Descriptions - Related Learning Group Page',
          fields: [
               'relatedPageHeadline',
               'relatedPageSubHeadline',
               'relatedPageBodyText',
               'relatedPageImage',
               'relatedPageAuthor',
               'relatedPageOverview',

               'relatedPageOrgHeadline',
               'relatedPageOrgSubHeadline',
               'relatedPageOrgBodyText',
               'relatedPageOrgImage',
               'relatedPageOrgAuthor',
               'relatedPageOrgOverview',
          ],
     },
     {
          name: 'Learning Descriptions - Learning Roadmap',
          fields: [
               'learningHeadline',
               'learningDescription',
               'learningRoadMapHeadline',
               'learningRoadMapDescription',

               'eventHeadline',
               'eventButtonText',

               'seatManageHeadline',
               'seatManageSubheadline',
               'seatManageDescription',
          ],
     },
     {
          name: 'Learning Descriptions',
          fields: [
               // 'learningHeadline',
               // 'learningDescription',
               'gettingStarted',
               'courseObjective',
               'courseMaterial',
               'courseDocument',
               'tipsFaqs',
               // 'learningRoadMapHeadline',
               // 'learningRoadMapDescription',
          ],
     },

     {
          name: 'Course Introduction Document',
          fields: ['courseDocument'],
     },
     {
          name: 'Discount Information',
          fields: ['discount', 'discountType', 'discountStartAt', 'discountEndAt'],
     },
];

export const TABS = {
     ALTERNATE_EMAIL: 'alternate-emails',
     CERTIFICATION_STATUS: 'certification-status',
     EMAIL: 'email',
     EVENT: 'event',
     EVENT_CREDIT: 'event-credit',
     FAQ: 'faq',
     GENERAL: 'general',
     INSTRUCTOR: 'instructor',
     LESSON_EDIT: 'lesson-edit',
     LESSON: 'lesson',
     LINK_INVENTORY: 'link-inventory',
     MEDIA: 'media',
     ORGANIZATION_ACCESS: 'organization-access',
     PREREQUISITE: 'prerequisite',
     PRODUCT_ACCESS: 'product-access',
     PROFESSIONAL_FIELD: 'professional--fields',
     PURCHASE: 'purchases',
     REVIEW: 'review',
     WAIT_LIST: 'wait-list',
     BUNDLED_SEATS: 'bundled-seats',
     VOUCHER_RULES: 'voucher-rules',
     VOUCHER_CODES: 'voucher-codes',
};

export const SECTION_TRAINING_EVENT_NAME = {
     SYSTEM_CONFIGURATION: 'System Configuration',
     DATE_AND_INSTRUCTOR: 'Date & Instructor',
     ATTACHED_LEARNING_ELEMENTS: 'Attached Learning Elements',
     LOCATION: 'Location',
     SELLING_DESCRIPTIONS: 'Selling Descriptions',
     LEARNING_DESCRIPTIONS: 'Learning Descriptions',
     CONFIRM_ATTENDEES: 'Confirm Attendees',
     COURSE_DOCUMENTS: 'Course Introduction Document',
     CUSTOM_DATE_PURCHASE_DETAILS: 'Custom Date Purchase Details',
     SEATS_AND_TRAINEES: 'Seats and Trainees',
     ASSIGNED_ORGANIZATIONS: 'Assigned Organizations',
};

export const PRODUCT_CREDIT_STATUS = {
     UNASSIGNED: 'UNASSIGNED',
     RESERVED: 'RESERVED',
     NO_SELECTED: 'NO_SELECTED',
     SELECTED: 'SELECTED',
};

export const PRODUCT_CREDIT_STATUS_LABEL = {
     UNASSIGNED: 'Unassigned',
     RESERVED: 'Reserved',
     NO_SELECTED: 'No Selected',
     SELECTED: 'Selected',
};

export const PRODUCT_BUNDLE_STATUS_LABEL = {
     open: 'OPEN',
     reserved: 'RESERVED',
     accepted: 'ACCEPTED',
};

export const PRODUCT_MODE = {
     BASIC: 'BASIC',
     ADVANCE: 'ADVANCE',
};

export const TRAINING_VIEWS = {
     all: 'VIEW ALL TRAININGS',
     own: 'TRAINING I OWN',
     dont_own: "TRAINING I DON'T OWN",
};

export const TRAINING_VIEWS_MANAGE_SEATS = {
     all: 'VIEW ALL TRAINING',
     own: 'TRAINING WE OWN',
     dont_own: "TRAINING WE DON'T OWN",
};

export const LOCATION_TYPE = {
     ONLINE: 'online',
     IN_PERSON: 'in-person',
};

export const PRODUCT_MEDIA_DIGITAL_DOCUMENT = 'digital-document';
